import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const X: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 300 300.251"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M168.57 132.15 265.27 20h-26.46l-82.03 95.38L89.34 20H15l102.13 146.93L15 280.25h26.46l87.4-101.59 71.8 101.59h79.34M51.01 39.54H86.66l157.13 222.13h-35.66"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};

export default X;
